import { AutoCompleteRequest } from "@telegraphio/bapi-types";
import { autocompleteApi } from "../adapters";
import { useEnhancedMutation } from "./useEnhancedMutation";

export function useAutocompleteEquipmentId() {
  return useEnhancedMutation({
    mutationFn: async ({ customerId, requestData }: { customerId: string; requestData: AutoCompleteRequest }) => {
      const data = await autocompleteApi.autocompleteEquipmentId(customerId, requestData);

      return data;
    },
    notifications: {
      error: { message: "Unable to load autocomplete equipment id" },
    },
  });
}

export function useAutocompleteScac() {
  return useEnhancedMutation({
    mutationFn: async ({ customerId, requestData }: { customerId: string; requestData: AutoCompleteRequest }) => {
      const data = await autocompleteApi.autocompleteScac(customerId, requestData);

      return data;
    },
    notifications: {
      error: { message: "Unable to load autocomplete scac" },
    },
  });
}

export function useAutocompleteUsers() {
  return useEnhancedMutation({
    mutationFn: async ({ customerId, requestData }: { customerId: string; requestData: AutoCompleteRequest }) => {
      const data = await autocompleteApi.autocompleteUsers(customerId, requestData);

      return data;
    },
    notifications: {
      error: { message: "Unable to load autocomplete users" },
    },
  });
}
